import { motion, VariantLabels } from 'framer-motion';

import { ParsedUrlQueryInput } from 'querystring';
import { ReactNode } from 'react';
interface Props {
  children: ReactNode;
  animationInitial?: any;
  animate?: any;
  className?: string;
}

export default function PageTransition({ children, animationInitial, animate, className }: Props) {
  return (
    <motion.div
      initial={animationInitial}
      animate={animate}
      transition={{ stiffness: 100, x: { duration: 0.4 }, y: { duration: 0.4 } }}
      className={`grow flex flex-col w-full mx-auto items-start ${className || ''}`}
    >
      {children}
    </motion.div>
  );
}
